import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { FiPlus, FiEdit2, FiTrash2, FiSave, FiX, FiUser, FiEye, FiEyeOff } from 'react-icons/fi';
import './UserPMB.css';

const UserPMB = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    phone: '',
    role: 'calon_mahasiswa',
    status: 'pending',
    program_studi: '',
    jalur_pendaftaran: 'Reguler'
  });
  const [selectedUser, setSelectedUser] = useState(null);
  const [filterStatus, setFilterStatus] = useState('');
  const [filterProdi, setFilterProdi] = useState('');

  const programStudiOptions = [
    'Profesi Ners',
    'S1 Keperawatan',
    'S1 Kesehatan Masyarakat'
  ];

  const jalurPendaftaranOptions = [
    'Reguler',
    'Transfer',
    'RPL Perolehan',
    'RPL Transfer'
  ];

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const res = await axios.get('/api/pmb/users');
      setUsers(res.data.data);
    } catch (error) {
      toast.error('Gagal mengambil data user');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleOpenModal = (user = null) => {
    if (user) {
      setEditMode(true);
      setSelectedUser(user);
      setFormData({
        name: user.name,
        email: user.email,
        password: '',
        phone: user.phone || '',
        role: user.role,
        status: user.status,
        program_studi: user.program_studi || '',
        jalur_pendaftaran: user.jalur_pendaftaran || 'Reguler'
      });
    } else {
      setEditMode(false);
      setSelectedUser(null);
      setFormData({
        name: '',
        email: '',
        password: '',
        phone: '',
        role: 'calon_mahasiswa',
        status: 'pending',
        program_studi: '',
        jalur_pendaftaran: 'Reguler'
      });
    }
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditMode(false);
    setSelectedUser(null);
    setShowPassword(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.name || !formData.email) {
      toast.error('Nama dan email wajib diisi');
      return;
    }

    if (!editMode && !formData.password) {
      toast.error('Password wajib diisi untuk user baru');
      return;
    }

    try {
      const dataToSend = { ...formData };
      if (editMode && !dataToSend.password) {
        delete dataToSend.password;
      }

      if (editMode) {
        await axios.put(`/api/pmb/users/${selectedUser._id}`, dataToSend);
        toast.success('Data user berhasil diupdate');
      } else {
        await axios.post('/api/pmb/users', dataToSend);
        toast.success('User berhasil ditambahkan');
      }
      
      handleCloseModal();
      fetchUsers();
    } catch (error) {
      toast.error(error.response?.data?.message || 'Terjadi kesalahan');
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Apakah Anda yakin ingin menghapus user ini?')) {
      try {
        await axios.delete(`/api/pmb/users/${id}`);
        toast.success('User berhasil dihapus');
        fetchUsers();
      } catch (error) {
        toast.error('Gagal menghapus user');
      }
    }
  };

  const updateStatus = async (id, newStatus) => {
    try {
      await axios.patch(`/api/pmb/users/${id}/status`, { status: newStatus });
      toast.success(`Status berhasil diubah menjadi ${newStatus}`);
      fetchUsers();
    } catch (error) {
      toast.error('Gagal mengubah status');
    }
  };

  const filteredUsers = users.filter(user => {
    const matchStatus = !filterStatus || user.status === filterStatus;
    const matchProdi = !filterProdi || user.program_studi === filterProdi;
    return matchStatus && matchProdi;
  });

  const formatTanggal = (tanggal) => {
    return new Date(tanggal).toLocaleDateString('id-ID', {
      day: '2-digit',
      month: 'long',
      year: 'numeric'
    });
  };

  if (loading) {
    return <div className="spinner"></div>;
  }

  return (
    <div className="user-pmb-page">
      {/* Header */}
      <div className="modern-header">
        <div className="header-background">
          <div className="header-pattern"></div>
        </div>
        <div className="header-content">
          <div className="header-text">
            <div className="header-icon-wrapper">
              <FiUser className="header-icon" />
            </div>
            <div>
              <h1>User PMB</h1>
              <p>Kelola akun calon mahasiswa dan pendaftar</p>
            </div>
          </div>
          <div className="header-actions">
            <button className="btn btn-glass" onClick={() => handleOpenModal()}>
              <FiPlus /> Tambah User
            </button>
          </div>
        </div>
      </div>

      {/* Stats */}
      <div className="stats-grid stats-grid-4">
        <div className="stat-card">
          <div className="stat-icon" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
            <FiUser />
          </div>
          <div className="stat-details">
            <h3>{users.length}</h3>
            <p>Total User</p>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon" style={{ background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)' }}>
            <FiUser />
          </div>
          <div className="stat-details">
            <h3>{users.filter(u => u.status === 'pending').length}</h3>
            <p>Pending</p>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon" style={{ background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)' }}>
            <FiUser />
          </div>
          <div className="stat-details">
            <h3>{users.filter(u => u.status === 'approved').length}</h3>
            <p>Disetujui</p>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon" style={{ background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)' }}>
            <FiUser />
          </div>
          <div className="stat-details">
            <h3>{users.filter(u => u.status === 'registered').length}</h3>
            <p>Terdaftar</p>
          </div>
        </div>
      </div>

      {/* Filters */}
      <div className="card">
        <div className="filters">
          <div className="search-box">
            <select 
              className="filter-select"
              value={filterStatus}
              onChange={(e) => setFilterStatus(e.target.value)}
            >
              <option value="">Semua Status</option>
              <option value="pending">Pending</option>
              <option value="approved">Disetujui</option>
              <option value="rejected">Ditolak</option>
              <option value="registered">Terdaftar</option>
            </select>
          </div>
          <div className="search-box">
            <select 
              className="filter-select"
              value={filterProdi}
              onChange={(e) => setFilterProdi(e.target.value)}
            >
              <option value="">Semua Program Studi</option>
              {programStudiOptions.map(prodi => (
                <option key={prodi} value={prodi}>{prodi}</option>
              ))}
            </select>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="card">
        <div className="modern-table-container">
          <table className="modern-table">
            <thead>
              <tr>
                <th>No</th>
                <th>Nama</th>
                <th>Email</th>
                <th>Telepon</th>
                <th>Program Studi</th>
                <th>Jalur</th>
                <th>Status</th>
                <th>Tgl. Daftar</th>
                <th>Aksi</th>
              </tr>
            </thead>
            <tbody>
              {filteredUsers.length === 0 ? (
                <tr>
                  <td colSpan="9" style={{ textAlign: 'center', padding: '40px' }}>
                    Tidak ada data user
                  </td>
                </tr>
              ) : (
                filteredUsers.map((user, index) => (
                  <tr key={user._id}>
                    <td>{index + 1}</td>
                    <td><strong>{user.name}</strong></td>
                    <td>{user.email}</td>
                    <td>{user.phone || '-'}</td>
                    <td>{user.program_studi || '-'}</td>
                    <td>{user.jalur_pendaftaran || '-'}</td>
                    <td>
                      <select
                        className={`status-select status-${user.status}`}
                        value={user.status}
                        onChange={(e) => updateStatus(user._id, e.target.value)}
                      >
                        <option value="pending">Pending</option>
                        <option value="approved">Disetujui</option>
                        <option value="rejected">Ditolak</option>
                        <option value="registered">Terdaftar</option>
                      </select>
                    </td>
                    <td>{formatTanggal(user.createdAt)}</td>
                    <td>
                      <div className="table-actions">
                        <button
                          className="table-btn table-btn-edit"
                          onClick={() => handleOpenModal(user)}
                          title="Edit"
                        >
                          <FiEdit2 />
                        </button>
                        <button
                          className="table-btn table-btn-delete"
                          onClick={() => handleDelete(user._id)}
                          title="Hapus"
                        >
                          <FiTrash2 />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>{editMode ? 'Edit User PMB' : 'Tambah User PMB'}</h3>
              <button className="modal-close" onClick={handleCloseModal}>&times;</button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="modal-body">
                <div className="form-grid">
                  <div className="form-group">
                    <label>Nama Lengkap <span className="required">*</span></label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="Nama lengkap"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label>Email <span className="required">*</span></label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="email@example.com"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label>Password {!editMode && <span className="required">*</span>}</label>
                    <div className="password-input-wrapper">
                      <input
                        type={showPassword ? 'text' : 'password'}
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        className="form-control"
                        placeholder={editMode ? 'Kosongkan jika tidak diubah' : 'Masukkan password'}
                        required={!editMode}
                      />
                      <button
                        type="button"
                        className="password-toggle"
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? <FiEyeOff /> : <FiEye />}
                      </button>
                    </div>
                  </div>

                  <div className="form-group">
                    <label>Nomor Telepon</label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="08xxxxxxxxxx"
                    />
                  </div>

                  <div className="form-group">
                    <label>Program Studi</label>
                    <select
                      name="program_studi"
                      value={formData.program_studi}
                      onChange={handleChange}
                      className="form-control"
                    >
                      <option value="">Pilih Program Studi</option>
                      {programStudiOptions.map(prodi => (
                        <option key={prodi} value={prodi}>{prodi}</option>
                      ))}
                    </select>
                  </div>

                  <div className="form-group">
                    <label>Jalur Pendaftaran</label>
                    <select
                      name="jalur_pendaftaran"
                      value={formData.jalur_pendaftaran}
                      onChange={handleChange}
                      className="form-control"
                    >
                      {jalurPendaftaranOptions.map(jalur => (
                        <option key={jalur} value={jalur}>{jalur}</option>
                      ))}
                    </select>
                  </div>

                  <div className="form-group">
                    <label>Status</label>
                    <select
                      name="status"
                      value={formData.status}
                      onChange={handleChange}
                      className="form-control"
                    >
                      <option value="pending">Pending</option>
                      <option value="approved">Disetujui</option>
                      <option value="rejected">Ditolak</option>
                      <option value="registered">Terdaftar</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label>Role</label>
                    <select
                      name="role"
                      value={formData.role}
                      onChange={handleChange}
                      className="form-control"
                    >
                      <option value="calon_mahasiswa">Calon Mahasiswa</option>
                      <option value="admin_pmb">Admin PMB</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>
                  <FiX /> Batal
                </button>
                <button type="submit" className="btn btn-primary">
                  <FiSave /> {editMode ? 'Update' : 'Simpan'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserPMB;
